import { JsonMapUtil, getClazz } from './json-map.util';
declare var Reflect: any;


export class BaseModel {
  id: number = undefined as any;

  createdAt: Date = undefined as any;
  updatedAt: Date = undefined as any;
  deletedAt: Date = undefined as any;
  activated: number = undefined as any;

  parse(json: Object) {
    if (json) {
      JsonMapUtil.deserialize(null as any, json, this);
    }
    return this;
  }
}
